import { render, staticRenderFns } from "./loginByMobile.vue?vue&type=template&id=53d263a8&scoped=true&"
import script from "./loginByMobile.vue?vue&type=script&lang=js&"
export * from "./loginByMobile.vue?vue&type=script&lang=js&"
import style0 from "./loginByMobile.vue?vue&type=style&index=0&id=53d263a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d263a8",
  null
  
)

export default component.exports